import { render, staticRenderFns } from "./JokesSection.vue?vue&type=template&id=e08ce904&"
import script from "./JokesSection.vue?vue&type=script&lang=js&"
export * from "./JokesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports